enum Message {
  NONE = 'none',
  AHOY_DISCOVER_PERFECT_CRUISE = 'ahoy-discover-perfect-cruise',
  BYE_BYE_BUCKET_LIST_HELLO_ADVENTURE = 'bye-bye-bucket-list-hello-adventure',
  EXPLORE_WORLD_TRAVEL = 'explore-world-travel',
  FIND_PERFECT_CAR_RENTAL = 'find-perfect-car-rental',
  FIND_PERFECT_GETAWAY_PACKAGE = 'find-perfect-getaway-package',
  HOTEL_TREEHOUSE_FIND_PERFECT_PLACE_STAY = 'hotel-treehouse-find-perfect-place-stay',
  MAKE_EXCITING_ACTIVITIES_ATTRACTIONS = 'make-exciting-activities-attractions',
  READY_TAKEOFF_FIND_PERFECT_FLIGHT = 'ready-takeoff-find-perfect-flight',
  SEARCH_HOTELS_FLIGHTS_CARS_ACTIVITIES_MORE = 'search-hotels-flights-cars-activities-more',
  SNOW_DAYS_FIND_ULTIMATE_SKI_GETAWAY = 'snow-days-find-ultimate-ski-getaway',
  START_TRAVEL_PLANNING = 'start-travel-planning',
  SUN_SEEKER_FIND_PERFECT_BEACH_GETAWAY = 'sun-seeker-find-perfect-beach-getaway',
}

export { Message };
